import { css } from '@emotion/react';

const historyMenuListStyles = {
    container: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
    }),
    list: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
    }),
    listItem: css({
        padding: '15px',
    }),
    listElement: css({
        padding: '15px 10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        textDecoration: 'none',
        fontWeight: 500,
        fontSize: 15,
        color: '#000000',
    }),
    historyItemLink: css({
        // fz
    }),
    historyItemContent: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        marginRight: 16,
    }),
    historyItemTopLine: css({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        marginBottom: 5,
    }),
    chevronRight: css({
        width: 24,
        height: 24,
    }),
    chevronRightSmall: css({
        width: 16,
        height: 16,
    }),
    historyItemDate: css({
        fontSize: 16,
        fontWeight: 700,
        color: '#000000',
    }),
    historyItemPrice: css({
        fontSize: 14,
        fontWeight: 400,
        color: '#000000',
    }),
    historyItemData: css({
        fontSize: 14,
        fontWeight: 400,
        color: '#000000',
    })
};

export default historyMenuListStyles;